import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { MapPreview } from '../../components/MapPreview';
import { getStaticMapUrl } from '../../selectors/newbuilding';

export function MapPreviewContainer() {
  const mapPreview = useSelector(getStaticMapUrl);

  if (!mapPreview) {
    return null;
  }

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#infrastructure',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
  };

  return <MapPreview mapPreview={mapPreview} onClick={onClick} />;
}
